import { useRouteMatch } from 'react-router-dom';

const useCurrentPath = () => {
  const routeMatch = useRouteMatch();

  if (routeMatch === null) {
    throw new Error('Unexpectedly missing route match response');
  }

  const { path } = routeMatch;

  return { path };
};

export default useCurrentPath;
